<template>
  <!-- 二维码扫描登录组件 -->
  <div class="phoneLoginDiv" v-show="isPhoneShow">
    <div class="phoneLoginTemplate">
      <a href="javascript:;" class="closePhoneLayBtn" @click="closephoneLogin">
        <img src="@/common/img/phoneLoginClose.png" />
      </a>
      <!-- 手机登录-start -->
      <div class="phoneLogin phoneCon" v-show="phoneLoginShow">
        <div class="phoneLayTitle">手机登录</div>
        <div class="formInput">
          <input type="text" placeholder="请输入手机号码" v-model="phone" />
        </div>
        <div class="passWordInput formInput">
          <input :type="passwordType" placeholder="请输入登录密码" @keyup.enter="phoneLoginSubmit()" v-model="password" />
          <i @click="passwordStatus">
            <img src="../phoneLogin/img/passwordHide.png" class="img1" v-show="passwordHide" />
            <img src="../phoneLogin/img/passwordShow.png" class="img2" v-show="passwordShow" />
          </i>
        </div>
        <a href="javascript:;" class="forgetPassWordBtn" @click="forgetPassWord">忘记密码？</a>
        <a href="javascript:;" class="loginSubmit" @click="phoneLoginSubmit">确定</a>
        <a href="javascript:;" class="ewmLoginBtn" v-on:click="ewmLoginBtn">
          <img src="@/common/img/wxIco.png" />切换微信扫码登录
        </a>
      </div>
      <!-- 手机登录-end -->
      <!-- 找回密码-start -->
      <div class="findPassWord phoneCon" v-show="findPassWordShow">
        <div class="phoneLayTitle">{{ phoneLayTitle }}</div>
        <div class="formInput">
          <input type="text" disabled placeholder="请输入手机号码" v-model="phone" />
        </div>
        <div class="passWordInput formInput">
          <input :type="passwordType" placeholder="请输入新密码" v-model="findPassword" />
          <i @click="passwordStatus">
            <img src="../phoneLogin/img/passwordHide.png" class="img1" v-show="passwordHide" />
            <img src="../phoneLogin/img/passwordShow.png" class="img2" v-show="passwordShow" />
          </i>
        </div>
        <!-- <div class="codeInput formInput">
          <input type="text" placeholder="请输入验证码" v-model="code" />
          <input type="text" class="code" v-model="sendCode" v-bind="{ 'disabled': disabled }" @click="sendCodeNum" />
        </div> -->
        <a href="javascript:;" class="loginSubmit" @click="findPassWordSubmit">确定</a>
      </div>
      <!-- 找回密码-end -->
    </div>
    <div class="phoneLayCloseBg" @click="closephoneLogin"></div>
  </div>
</template>

<script>
import { getVersion } from "@/api/requestUrl"; //公共js
export default {
  name: "phoneLoginDiv",
  data() {
    return {
      isPhoneShow: false,
      phone: "",
      password: "",
      findPassword: "",
      code: "",
      sendCode: "发送验证码",
      passwordHide: false, //隐藏密码图标是否显示
      passwordShow: true, //显示密码图标是否显示
      passwordType: "password", //密码输入框的类型
      phoneLoginShow: true, //手机登录
      findPassWordShow: false, //找回密码
      time: 0, //发送验证码间隔时间
      disabled: false, //按钮状态
      phoneLayTitle: "设置密码",
      isBindPhoneStatus: true //是否绑定手机号码
    };
  },
  props: {
    phoneLoginLayShow: Boolean
  },
  methods: {
    //切换微信登录
    ewmLoginBtn: function () {
      this.$emit("ewmLoginBtn");
    },

    //打开手机登录
    openPhoneLogin: function () {
      var that = this;
      that.isPhoneShow = true;
    },

    //关闭手机登录
    closePhoneLogin: function () {
      var that = this;
      that.isPhoneShow = false;
      // if (that.isBindPhoneStatus != true) {
      //   location.reload(); //登录成功后刷新页面
      // }
    },

    //关闭登录弹窗
    closephoneLogin: function () {
      var that = this;
      that.isPhoneShow = false;
      console.log(that.isBindPhoneStatus);
      // if (that.isBindPhoneStatus != true) {
      //   location.reload(); //登录成功后刷新页面
      // }
    },

    //是否显示密码
    passwordStatus: function () {
      var that = this;
      if (that.passwordShow == true) {
        that.passwordShow = false;
        that.passwordHide = true;
        that.passwordType = "text";
      } else {
        that.passwordShow = true;
        that.passwordHide = false;
        that.passwordType = "password";
      }
    },

    /*
     * 忘记密码
     */
    forgetPassWord: function () {
      var that = this;
      that.phoneLoginShow = false;
      that.findPassWordShow = true;
    },

    //登录
    phoneLoginSubmit: function () {
      var that = this;
      var reg = /^1\d{10}$/; //手机号正则验证
      var phoneNum = that.phone;
      var passwordNum = that.password;
      var phoneCodeNum = that.code;
      if (!phoneNum) {
        //未输入手机号
        that.$message({
          message: "请输入手机号码",
          type: "warning"
        });
        return;
      }
      if (!reg.test(phoneNum)) {
        //手机号不合法
        that.$message({
          message: "手机号码格式不正确",
          type: "error"
        });
        return;
      }
      if (!passwordNum) {
        //未输入密码
        that.$message({
          message: "请输入密码",
          type: "warning"
        });
        return;
      }

      that.requestApi({
        method: "get",
        url: "/api/login/phoneLogin",
        data: {
          phone: phoneNum,
          password: passwordNum
        },
        then(data) {
          //elementUI提供的提示框
          that.$message({
            message: "登录成功",
            type: "success"
          });

          if (getVersion() == "dev") {
            that.$alert("温馨提示：测试版本数据仅限于通信行业，时间为2019年1月1日至2019年10月31日。", "提示", {
              confirmButtonText: "确定",
              callback: action => {
                that.loginSuccess();
              }
            });
          } else {
            that.loginSuccess();
          }

        }
      });
    },
    loginSuccess: function () {
      setTimeout(() => {
        // window.location.reload(); //登录成功后刷新页面
        if (location.href.indexOf("restLogin") !== -1) {
          // location.href =
          //   location.origin + location.pathname + "#/index";
          that.$router.push({
            path: "/index" //跳转的路由
          });
        } else {
          location.reload(); //登录成功后刷新页面
        }
      }, 1500);
    },
    //发送验证码
    sendCodeNum: function () {
      var that = this;
      var reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/; //手机号正则验证
      var phoneNum = that.phone;
      if (!phoneNum) {
        //未输入手机号
        that.$message({
          message: "请输入手机号码",
          type: "warning"
        });
        return;
      }
      if (!reg.test(phoneNum)) {
        //手机号不合法
        that.$message({
          message: "手机号码格式不正确",
          type: "error"
        });
        return;
      }
      that.time = 60;
      that.timer();
      console.log("that.isBindPhoneStatus" + that.isBindPhoneStatus);
      if (that.isBindPhoneStatus == true) {
        // 获取验证码请求
        that.requestApi({
          method: "get",
          url: "/api/login/getPasswordPhoneCode",
          data: {
            phone: that.phone
          },
          then(data) {
            //elementUI提供的提示框
            that.$message({
              message: "验证码已发送",
              type: "success"
            });
          }
        });
      } else {
        // 未绑定手机号码-获取验证码请求
        that.requestApi({
          method: "get",
          url: "/api/phoneVerification",
          data: {
            phone: that.phone
          },
          then(data) {
            //elementUI提供的提示框
            that.$message({
              message: "验证码已发送",
              type: "success"
            });
          }
        });
      }
    },

    //手机验证码倒计时
    timer: function () {
      if (this.time > 0) {
        this.time--;
        this.sendCode = this.time + "s后重新获取";
        this.disabled = true;
        var timer = setTimeout(this.timer, 1000);
      } else if (this.time == 0) {
        this.sendCode = "获取验证码";
        clearTimeout(timer);
        this.disabled = false;
      }
    },

    //重置登录密码
    findPassWordSubmit: function () {
      var that = this;
      var reg = 11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/; //手机号正则验证
      var phoneNum = that.phone;
      var passwordNum = that.findPassword;
      // var phoneCodeNum = that.code;
      if (!phoneNum) {
        //未输入手机号
        that.$message({
          message: "请输入手机号码",
          type: "warning"
        });
        return;
      }
      if (!reg.test(phoneNum)) {
        //手机号不合法
        that.$message({
          message: "手机号码格式不正确",
          type: "error"
        });
        return;
      }
      if (!passwordNum) {
        //未输入密码
        that.$message({
          message: "请输入密码",
          type: "warning"
        });
        return;
      }
      // if (!phoneCodeNum) {
      //   //未输入手机验证码
      //   that.$message({
      //     message: "请输入验证码",
      //     type: "warning"
      //   });
      //   return;
      // }
      //未绑定手机号码
      if (that.isBindPhoneStatus != true) {
        that.requestApi({
          method: "get",
          url: "/api/login/bindPhone",
          data: {
            phone: phoneNum,
            password: passwordNum,
            // code: phoneCodeNum
          },
          then(data) {
            //elementUI提供的提示框
            that.$message({
              message: "手机号码绑定成功",
              type: "success"
            });
            setTimeout(() => {
              window.location.reload(); //成功后刷新页面
            }, 2000);
          }
        });
      } else {
        that.requestApi({
          method: "get",
          url: "/api/login/updatePassword",
          data: {
            phone: phoneNum,
            password: passwordNum,
            phoneCode: ''
          },
          then(data) {
            //elementUI提供的提示框
            that.$message({
              message: "重置密码成功",
              type: "success"
            });
            //退出登录
            that.requestApi({
              method: "get",
              url: "/api/login/exit",
              then(data) { }
            });
            setTimeout(() => {
              window.location.reload(); //成功后刷新页面
            }, 2000);
          }
        });
      }
    },

    //打开修改密码界面
    openFindPassWord: function () {
      var that = this;
      //查询是否已经绑定手机了
      this.requestApi({
        method: "get",
        url: "/api/login/isBindingPhone",
        data: {},
        then(data) {
          console.log("data:" , data.data);
          if (!data.data) {
            that.$message({
              message: "请在移动端绑定手机号码后，再设置密码。",
              type: "error"
            });
          } else {
            that.phone = data.data
            that.isPhoneShow = true;
            that.phoneLoginShow = false; //手机登录
            that.findPassWordShow = true; //找回密码
          }
        }
      });
    },

    //绑定手机
    openBindPhone: function () {
      return
      var that = this;
      console.log("*****************************")
      that.phoneLayTitle = "绑定手机";
      that.isPhoneShow = true;
      that.phoneLoginShow = false;
      that.findPassWordShow = true;
      console.log("that.isPhoneShow:" + that.isPhoneShow)
      console.log("that.findPassWordShow:" + that.findPassWordShow)
      that.requestApi({
        method: "get",
        url: "/api/user/isBindingPhone",
        data: {},
        then(data) {
          console.log("data:" + data.data);
          that.isBindPhoneStatus = data.data;
        }
      });
    }
  },
  watch: {
    phoneLoginLayShow(val) {
      this.isPhoneShow = val;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.phoneLoginDiv {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
}

.phoneLoginTemplate {
  position: relative;
  top: 50%;
  left: 50%;
  width: 460px;
  height: 434px;
  z-index: 1100;
  background: #fff url(../phoneLogin/img/phoneLayTitleBg.png) center top no-repeat;
  background-size: 436px 145px;
  margin-top: -267px;
  margin-left: -230px;
}

.phoneLayCloseBg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.2);
}

.phoneLoginTemplate .closePhoneLayBtn img {
  position: absolute;
  top: 14px;
  right: 14px;
}

.phoneLayTitle {
  font-size: 24px;
  color: #2b5f80;
  text-align: center;
  padding-top: 52px;
}

.phoneCon {
  padding: 0 70px;
}

.phoneCon .formInput {
  height: 52px;
  line-height: 52px;
  border-bottom: 1px solid #b3b3b3;
  position: relative;
}

.passWordInput {
  padding-right: 25px;
}

.passWordInput i .img1 {
  position: absolute;
  top: 50%;
  right: 0;
  margin-top: -8.5px;
  cursor: pointer;
}

.passWordInput i .img2 {
  position: absolute;
  top: 50%;
  right: 0;
  margin-top: -7px;
  cursor: pointer;
}

.codeInput {
  padding-right: 80px;
}

.phoneCon .formInput input {
  height: 52px;
  line-height: 52px;
  width: 100%;
  font-size: 14px;
}

.phoneCon .formInput .code {
  position: absolute;
  font-size: 16px;
  color: #2b5f80;
  top: 0;
  right: 0;
  line-height: 52px;
  display: inline-block;
  width: 120px;
  text-align: right;
  background: #fff;
  cursor: pointer;
}

.phoneLoginTemplate .loginSubmit {
  background: linear-gradient(162deg,
      rgba(51, 107, 142, 1) 0%,
      rgba(25, 159, 175, 1) 100%);
  color: #fff;
  display: block;
  height: 45px;
  line-height: 45px;
  text-align: center;
  font-size: 14px;
  margin: 33px auto 45px auto;
  cursor: pointer;
}

.phoneReg .loginSubmit {
  margin-top: 60px;
}

.findPassWord .loginSubmit {
  margin-top: 60px;
}

.forgetPassWordBtn {
  text-align: right;
  display: block;
  color: #535353;
  font-size: 14px;
}

.ewmLoginBtn {
  display: block;
  color: #535353;
  font-size: 14px;
  line-height: 29px;
}
</style>



// WEBPACK FOOTER //
// src/components/phoneLogin/phoneLogin.vue